// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__166iV","type":"styles_type__2aCkd","choices":"styles_choices__3R8kI"};